import React from 'react';

const FormContext = React.createContext({
  isSubmit: false,
  isApplyFormWrapper: false,
  dispatch: () => {},
});

export default FormContext;
